import axios from 'axios';
import { SubmissionError } from 'redux-form';

import { createActionType } from 'utils/redux';
import {
  apiCreateSequence,
  apiGetSequences,
  apiDuplicateSequence,
} from 'constants/apiRouting';
import {
  CREATE_SEQUENCE as CREATE_SEQUENCE_EVENT,
  UPDATE_SEQUENCE as UPDATE_SEQUENCE_EVENT,
} from 'constants/analytics';
import { handleErrors } from '../../utils/api';
import { apiSequence } from '../../constants/apiRouting';
import { analyticsTrack } from '../../utils/analytics';

// object
export const CREATE_SEQUENCE = createActionType('CREATE_SEQUENCE');
export const GET_SEQUENCE = createActionType('GET_SEQUENCE');
export const UPDATE_SEQUENCE = createActionType('UPDATE_SEQUENCE');
export const DUPLICATE_SEQUENCE = createActionType('DUPLICATE_SEQUENCE');
// objects
export const GET_SEQUENCES = createActionType('GET_SEQUENCES');

export const CLEAR_SEQUENCE_STORE = 'CLEAR_SEQUENCE_STORE';


export const createSequence = (params = {
  name: null,
  campaign: null,
  status: null,
  launch_date: null,
  schedule: null,
  validate_contacts: null,
  send_to_risky: null,
}) => async (dispatch) => {
  analyticsTrack(CREATE_SEQUENCE_EVENT, params, true);

  await dispatch({
    type: CREATE_SEQUENCE.name,
    payload: axios.post(
      apiCreateSequence(),
      params, { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
      throw new SubmissionError({ name: "Server Error, can't create sequence", _error: "can't create sequence" });
    }),
  });
};

export const clearSequenceStore = () => dispatch => dispatch({
  type: CLEAR_SEQUENCE_STORE,
  payload: {},
});


export const updateSequence = (
  sequenceId,
  params = {
    name: null,
    campaign: null,
    status: null,
    launch_date: null,
    schedule: null,
    validate_contacts: null,
    send_to_risky: null,
  },
) => async (dispatch) => {
  analyticsTrack(UPDATE_SEQUENCE_EVENT, {
    sequence: sequenceId,
    ...params,
  }, true);

  await dispatch({
    type: UPDATE_SEQUENCE.name,
    payload: axios.patch(
      apiSequence(sequenceId),
      params, { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};


export const getSequence = sequenceId => async (dispatch) => {
  await dispatch({
    type: GET_SEQUENCE.name,
    payload: axios.get(
      apiSequence(sequenceId),
      { withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};


export const destroySequence = sequenceId => async (dispatch) => {
  try {
    await axios.delete(
      apiSequence(sequenceId),
      { withCredentials: true },
    );
    await dispatch(clearSequenceStore());
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const getSequences = (
  campaignID,
  params = {
    search: null,
    page: null,
  },
) => async (dispatch) => {
  await dispatch({
    type: GET_SEQUENCES.name,
    payload: axios.get(
      apiGetSequences(campaignID),
      { params, withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};

export const getAccountSequences = (params = {
  search: null,
  campaign__account__id: null,
}) => async (dispatch) => {
  await dispatch({
    type: GET_SEQUENCES.name,
    payload: axios.get(
      apiCreateSequence(),
      { params, withCredentials: true },
    ).catch((error) => {
      handleErrors(error, dispatch);
    }),
  });
};

export const duplicateSequence = id => dispatch => dispatch({
  type: DUPLICATE_SEQUENCE.name,
  payload: axios.get(
    apiDuplicateSequence(id),
    { withCredentials: true },
  ).catch(error => handleErrors(error, dispatch)),
});
